import { Recipients } from "./recipient";
import { TagsDetails } from "./tags";

export interface MessageCompose {
  conversationId?: string;
  source?: string;
  sourceType: string;
  isTTSMode: boolean;
  isPriorityMessage: boolean;
  recipients: Recipients;
  deliveryTime?: Date;
  templateId: any;
  message: string;
  senderUsername: string;
  tagIds: TagsDetails[];
  contentType: string;
  placeholderDetails: object;
}

export type MsisdnOptionType = {
  id: number | string;
  label: string;
  value: string;
  type: string;
  originalType: string;
  showDefault?: boolean;
};

export class MessageCompose {
  constructor() {
    this.source = "";
    this.sourceType = "ALPHATAG";
    this.isTTSMode = false;
    this.isPriorityMessage = false;
    this.templateId = "";
    this.message = "";
    this.recipients = {};
    this.senderUsername = "";
    this.tagIds = [];
    this.contentType = "TEXT_PLAIN";
    this.placeholderDetails = {};
  }

  setSource(source: string) {
    this.source = source;
  }

  setSourceType(sourceType: string) {
    this.sourceType = sourceType;
  }
}
